import React, { Component, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import QrScanner from 'qr-scanner';
import { LoadingIndicator } from '../../components';

class QrCodeScanner extends Component {
  constructor(props) {
    super(props);

    this.videoRef = React.createRef();
    this.qrScanner = null;
  }

  componentDidMount() {
    this.initQrScanner();
  }

  componentWillUnmount() {
    this.destroyQrScanner();
  }

  initQrScanner() {
    if (!this.videoRef?.current) {
      return;
    }
    const { onQrCodeScanned } = this.props;

    this.qrScanner = new QrScanner(
      this.videoRef.current,
      result => {
        const { data } = result;
        onQrCodeScanned(data);
      }, {
        highlightCodeOutline: true,
      }
    );
    this.qrScanner.start();
  }

  destroyQrScanner() {
    if (!this.videoRef?.current) {
      return;
    }
    this.qrScanner.destroy();
    this.qrScanner = null;
  }

  render() {
    return (
      <video
        ref={this.videoRef}
        style={{ width: '100%', maxWidth: 500, maxHeight: 500 }}
      />
    );
  }
}

QrCodeScanner.propTypes = {
  onQrCodeScanned: PropTypes.func.isRequired,
};

const QrCodeScannerWrapper = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasCamera, setHasCamera] = useState(false);

  useEffect(() => {
    QrScanner.hasCamera()
      .then(resp => {
        setHasCamera(resp);
        return resp;
      })
      .catch(() => null)
      .finally(() => {
        setIsLoading(false);
      });
  }, [QrScanner]);

  if (isLoading) {
    return <LoadingIndicator />;
  }
  else if (hasCamera) {
    return <QrCodeScanner {...props}/>;
  }
  else {
    return <div>Camera not found!</div>;
  }
};

QrCodeScannerWrapper.propTypes = {
  onQrCodeScanned: PropTypes.func.isRequired,
};

export default QrCodeScannerWrapper;
